module.exports = __webpack_public_path__ + "media/images/vision-express-logo@2x-cf364e619da78a70ea823aa91b86a667.webp";